import React, { useRef, useEffect, useState } from 'react';
import { Stack, TextareaAutosize, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { useStyles } from '../styles/descriptionStyles';
import { useProject } from '../../Layout/header/context';
import { updateProject } from '../../../../services/projectService';

const ProjectDescription = () => {
  const classes = useStyles();
  const { projectDetails, refetchProject, setProjectDetails, isEditPermission } = useProject();
  const [disabled, setDisabled] = useState(false);
  const descriptionRef = useRef(null);

  const projectDescription = projectDetails?.description;

  const handleBlur = async (e) => {
    const description = e?.target?.value?.trim();
    if (!isEditPermission || description === projectDescription) return;
    try {
      setDisabled(true);
      await updateProject(projectDetails?.id, { description });
      setProjectDetails((prev) => ({ ...prev, description }));
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        'An error occurred while saving the project description. Please try again later.';
      toast.error(errMsg);
      refetchProject();
    } finally {
      setDisabled(false);
    }
  };

  useEffect(() => {
    if (descriptionRef.current?.value !== projectDescription) {
      descriptionRef.current.value = projectDescription;
    }
  }, [projectDescription]);
  return (
    <Stack spacing={1}>
      <Typography variant="h4" color="GrayText">
        Project Description
      </Typography>
      <TextareaAutosize
        placeholder="Write project description here..."
        minRows={3}
        defaultValue={projectDescription}
        className={classes.projectDescription}
        onBlur={handleBlur}
        ref={descriptionRef}
        disabled={!isEditPermission || disabled}
        style={{
          fontFamily: '"Public Sans", sans-serif',
          fontSize: '16px',
          color: '#333',
        }}
      />
    </Stack>
  );
};

export default ProjectDescription;
